



























import Vue from 'vue';
import { FIcon } from '@fkui/vue';
import { EReceipt } from '@exp/vue';
import { StatisticsService } from '@exp/vue';
import { fmiPersistenceService } from '@/storage';

export default Vue.extend({
    components: {
        FIcon,
        EReceipt,
    },
    data() {
        return {
            ansokan: fmiPersistenceService.get(),
        };
    },
    created() {
        StatisticsService.applicationFinished();
    },
    mounted() {
        this.focusOnHeader();
    },
    methods: {
        print(): void {
            window.print();
        },
        focusOnHeader() {
            const heading = this.$el.querySelector<HTMLElement>('h2');
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
            }
        },
    },
});
